module.exports = __webpack_public_path__ + "static/media/logo_with_text.5543c361.png";